import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="update-client-t-dm"
export default class extends Controller {
  connect() {
    console.log("updateClientTDmController connected");
  }

  async updateTVisible(event) {
    const tr = event.target.closest("tr");
    const clientId = tr.dataset.clientId;
    const tVisible = event.target.checked ? true : false;
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
    const response = await fetch(`/clients/${clientId}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({
        client: { t_visible: tVisible }
      })
    });
    if (response.ok) {
      const alert = document.createElement("div");
      alert.className = "alert alert-success alert-position text-center";
      alert.innerHTML = `成功しました。`;
      document.body.appendChild(alert);
      setTimeout(() => alert.remove(), 2000);
    } else {
      const alert = document.createElement("div");
      alert.className = "alert alert-danger alert-position text-center";
      alert.innerHTML = `失敗しました。`;
      document.body.appendChild(alert);
      setTimeout(() => alert.remove(), 2000);
    }
  }
  async updateDMVisible(event) {
    const tr = event.target.closest("tr");
    const clientId = tr.dataset.clientId;
    const dmVisible = event.target.checked ? true : false;
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
    const response = await fetch(`/clients/${clientId}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({
        client: { dm_visible: dmVisible }
      })
    });
    if (response.ok) {
      const alert = document.createElement("div");
      alert.className = "alert alert-success alert-position text-center";
      alert.innerHTML = `成功しました。`;
      document.body.appendChild(alert);
      setTimeout(() => alert.remove(), 2000);
    } else {
      const alert = document.createElement("div");
      alert.className = "alert alert-danger alert-position text-center";
      alert.innerHTML = `失敗しました。`;
      document.body.appendChild(alert);
      setTimeout(() => alert.remove(), 2000);
    }
  }
}
